import { Box, Typography } from '@mui/material'
import React from 'react'
import { Constants } from '../constants'
import { getImageUrl } from '../utils/getImageUrl'
import CustomDivider from '../utils/CustomDivider'

const AwardIconCard = ({ item }) => {
    return (
        <Box
            sx={{
                bgcolor: "#F0F0F0",
                borderRadius: "40px",
                px: "1.3rem",
                py: "1.3rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                justifyContent: "end",
                height: "350px"

            }}
        >
            <Box component={"img"} src={getImageUrl(item?.imageUrl)} sx={{ height: "250px", position: "absolute", top: "-40px" }} alt={`Award Image`} />

            <Typography variant='body2' fontWeight={200} dangerouslySetInnerHTML={{ __html: item?.text }} />
            <Typography variant='h6' sx={{ fontWeight: "700", mt: 1, color: "#861641" }} dangerouslySetInnerHTML={{ __html: item?.subText }} />
            <Typography variant='body1' sx={{ fontWeight: "600", }} dangerouslySetInnerHTML={{ __html: item?.year }} />



        </Box>
    )
}

export default AwardIconCard